import { fixLineBreaks } from 'components/MCTextEditor/dataFormat/parse/utils/fixLineBreaks'

import { AllowedValues } from '../types'

import { parseMCText } from './parse/parseMCText'
import { ParserContext } from './parse/types'
import { parseValue } from './parse/utils/parseValue'

export const createParseString = (context: ParserContext) => {
  return (input: AllowedValues) => {
    return parseMCText(fixLineBreaks(parseValue(input)), context)
  }
}
